// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path("", "/"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  verify: path(ROOTS_AUTH, "/verify"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page404: "/404",
  page500: "/500",
  components: "/components",
};

export const PATH_DASHBOARD = {
  root: "/",
  home: {
    root: path(ROOTS_DASHBOARD, "/home"),
    // AutomaticCalculation: path(ROOTS_DASHBOARD, "/Home/calculate"),
    OrderAnalysis: path(ROOTS_DASHBOARD, "/Home/orderanalytics"),
    // quantity: path(ROOTS_DASHBOARD, "/Home/quantity"),
    cookingrate: path(ROOTS_DASHBOARD, "/Home/cookingrate"),
  },
  sales: {
    root: path(ROOTS_DASHBOARD, "/Sales"),
    salesanaly: path(ROOTS_DASHBOARD, "/Sales/salesanaly"),
    salesbymenu: path(ROOTS_DASHBOARD, "/Sales/salesbymenu"),
    mapanalytics: path(ROOTS_DASHBOARD, "/Sales/mapanalytics"),
  },
  inventory: {
    root: path(ROOTS_DASHBOARD, "/inventory"),
    inventory: path(ROOTS_DASHBOARD, "/inventory"),
  },
  board: {
    root: path(ROOTS_DASHBOARD, "/board/notice"),
    notice: path(ROOTS_DASHBOARD, "/board/notice"),
  },
  sc_home: {
    root: path(ROOTS_DASHBOARD, "/sc_home"),
    sc_orderanalytics: path(ROOTS_DASHBOARD, "/sc_home/sc_orderanalytics"),
    sc_salesanalytics: path(ROOTS_DASHBOARD, "/sc_home/sc_salesanalytics"),
    sc_sellsanalytics: path(ROOTS_DASHBOARD, "/sc_home/sc_sellsanalytics"),
    sc_sellsdetailanalytics: path(
      ROOTS_DASHBOARD,
      "/sc_home/sc_sellsdetailanalytics"
    ),
    sc_mapanalytics: path(ROOTS_DASHBOARD, "/sc_home/sc_mapanalytics"),
  },
  sc_store: {
    root: path(ROOTS_DASHBOARD, "/sc_store"),
    sc_orderanalytics: path(ROOTS_DASHBOARD, "/sc_store/sc_orderanalytics"),
    sc_salesanalytics: path(ROOTS_DASHBOARD, "/sc_store/sc_salesanalytics"),
    sc_sellsanalytics: path(ROOTS_DASHBOARD, "/sc_store/sc_sellsanalytics"),
    sc_sellsdetailanalytics: path(
      ROOTS_DASHBOARD,
      "/sc_store/sc_sellsdetailanalytics"
    ),
  },
  sc_report: {
    root: path(ROOTS_DASHBOARD, "/sc_report"),
  },
  sc_board: {
    root: path(ROOTS_DASHBOARD, "/sc_board/sc_notice"),
    sc_notice: path(ROOTS_DASHBOARD, "/sc_board/sc_notice"),
    sc_noticeGroup: path(ROOTS_DASHBOARD, "/sc_board/sc_group"),
  },
  hq_home: {
    root: path(ROOTS_DASHBOARD, "/hq_home"),
    hq_salesanalytics: path(ROOTS_DASHBOARD, "/hq_home/hq_salesanalytics"),
    hq_sellsanalytics: path(ROOTS_DASHBOARD, "/hq_home/hq_sellsanalytics"),
  },
  hq_brand: {
    root: path(ROOTS_DASHBOARD, "/hq_brand"),
    hq_orderanalytics: path(ROOTS_DASHBOARD, "/hq_brand/hq_orderanalytics"),
    hq_salesanalytics: path(ROOTS_DASHBOARD, "/hq_brand/hq_salesanalytics"),
    hq_sellsanalytics: path(ROOTS_DASHBOARD, "/hq_brand/hq_sellsanalytics"),
    hq_sellsdetailanalytics: path(
      ROOTS_DASHBOARD,
      "/hq_brand/hq_sellsdetailanalytics"
    ),
    hq_mapanalytics: path(ROOTS_DASHBOARD, "/hq_brand/hq_mapanalytics"),
  },
  hq_store: {
    root: path(ROOTS_DASHBOARD, "/hq_store"),
    hq_orderanalytics: path(ROOTS_DASHBOARD, "/hq_store/hq_orderanalytics"),
    hq_salesanalytics: path(ROOTS_DASHBOARD, "/hq_store/hq_salesanalytics"),
    hq_sellsanalytics: path(ROOTS_DASHBOARD, "/hq_store/hq_sellsanalytics"),
    hq_sellsdetailanalytics: path(
      ROOTS_DASHBOARD,
      "/hq_store/hq_sellsdetailanalytics"
    ),
  },
  hq_report: {
    root: path(ROOTS_DASHBOARD, "/hq_report"),
  },
};
